export default {
  landDocuments: [],
  residentDocuments: [],
  selectedDocument: {},
  documentTypes: [],
  documentSignatures: [],
  allDocuments: [],
  missingDocuments: [],
  documentContexts: [],
  documentVariables: [],
  partnerDocuments: []
}
